<div hidden>
    <ng-container *ngIf="!!fields" #dsFieldsRef>
        <div *ngFor="let itm of fields">
            <label>{{ itm.name }}</label>
            <ul>
                <li *ngFor="let i of itm.fields">{{ i }}</li>
            </ul>
        </div>
    </ng-container>
    <ng-container *ngIf="!!textItems" #dsTextRef>
        <div
            *ngFor="let itm of textItems"
            draggable="true"
            (dragstart)="onDragTextStart($event, itm)"
        >
            <label [title]="itm.descr">{{ itm.name }}</label>
        </div>
    </ng-container>
</div>
